<template>
  <div class="swiper-container">
    <div class="swiper-button-custom-next">
      <img
        width="24"
        height="24"
        src="https://img.icons8.com/ios/50/forward--v1.png"
        alt="forward--v1"
      />
    </div>
    <div class="swiper-button-custom-prev">
      <img
        width="24"
        height="24"
        src="https://img.icons8.com/ios/50/back--v1.png"
        alt="back--v1"
      />
    </div>
    <swiper
      ref="mySwiper"
      @swiper="onSwiper"
      :slidesPerView="2.2"
      :spaceBetween="30"
      :navigation="{
        nextEl: '.swiper-button-custom-next',
        prevEl: '.swiper-button-custom-prev',
      }"
      :speed="500"
      :loop="true"
      :autoplay="{
        delay: 2500,
      }"
      :touch-ratio="1.5"
      :modules="modules"
      class="mySwiper"
    >
      <swiper-slide
        v-for="([parentId, category], index) in categories"
        :key="category.id"
        @click="goToSlide(index)"
      >
        <!-- Route to category when category block is clicked -->
        <router-link
          style="text-decoration: none; color: inherit"
          :to="getRoute(parentId, category)"
        >
          <SliderCategoryBlock :category="category" />
        </router-link>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import SliderCategoryBlock from "@/components/SliderCategoryBlock.vue";
import { Swiper, SwiperSlide } from "swiper/swiper-vue";
import "swiper/swiper-bundle.css";
import "swiper/modules/navigation.css";
import { Navigation, Autoplay } from "swiper/modules";

export default {
  name: "CategorySlider",
  components: {
    SliderCategoryBlock,
    Swiper,
    SwiperSlide,
  },
  props: {
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      translations: {},
      modules: [Navigation, Autoplay],
      swiper: null,
    };
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    goToSlide(index) {
      this.swiper.slideTo(index);
    },

    getRoute(parentId, category) {
      if (category.subCategories) {
        const parentsString = [parentId, category.id].join(",");
        // Route to categories with query
        return {
          name: "Categories",
          query: {
            lang: this.$route.query.lang,
            parent: parentsString,
          },
        };
      } else {
        const parentsString = [parentId].join(",");
        // Route to items
        return {
          name: "Items",
          query: {
            lang: this.$route.query.lang,
            parent: parentsString,
          },
          params: { id: category.id },
        };
      }
    },
  },
};
</script>

<style scoped>
.mySwiper {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 0.5rem;
  margin-bottom: 4%;
}

.swiper-container {
  position: relative;
}

.swiper-button-custom-next,
.swiper-button-custom-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.5); /* semi-transparent white */
  backdrop-filter: blur(5px); /* blur effect */
  width: 30px; /* adjust as needed */
  height: 100%;
  z-index: 2; /* bring to front */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-button-custom-next {
  right: 0;
}

.swiper-button-custom-prev {
  left: 0;
}
.swiper-slide-active {
  transform: scale(1.1);
  transition: transform 0.5s;
}
</style>
